var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('div',{attrs:{"id":"report_chart"}},[_c('apexchart',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }